import { render, staticRenderFns } from "./RejectionPage.vue?vue&type=template&id=74a2ee16&scoped=true"
import script from "./RejectionPage.vue?vue&type=script&lang=js"
export * from "./RejectionPage.vue?vue&type=script&lang=js"
import style0 from "./RejectionPage.vue?vue&type=style&index=0&id=74a2ee16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a2ee16",
  null
  
)

export default component.exports